const inistialStoreState = {
  boxType: null,
  currentBox: null,
  styles: null,
  colors: null,
  products: [{}, {}, {}],  // For custom box
  sizes: {       // For sets and premiums
      panty: null,
      pantyMeasure: null,
      braCup: null,
      braMeasure: null,
      braSizeChar: null
  },
  pagination: {
    currentPage: 1,
    totalPages: 4
  },
  currentStep: 'eby-sub4-plan',
  stepsVisited: ['eby-sub4-plan'],
  cbopts: [],
  collectionPanty: [],
};

const intialPlanState = {
  boxType: null,
  currentBox: [],
}

class EbySubscriptionStore {
  constructor(initialState, reducer) {
      this.state = initialState;
      this.listeners = [];
      this.reducer = reducer;
  }
  
  dispatch(action) {
    this.state = this.reducer(this.state, action);
    this.notifyListeners();
    this.print(action); //temp

    vela.subFour = this.state;
  }
  
  // Get current state
  getState() {
      return this.state;
  }

  // Update state (you can modify this to include merging logic, etc.)
  setState(newState) {
      this.state = newState;
      this.notifyListeners();
  }

  // Listen to state changes
  subscribe(listener) {
      this.listeners.push(listener);
      return () => { // Return an unsubscribe function
          const index = this.listeners.indexOf(listener);
          if (index > -1) {
              this.listeners.splice(index, 1);
          }
      };
  }

  // Notify all subscribers of state change
  notifyListeners() {
      for (const listener of this.listeners) {
          listener(this.state);
      }
  }

  print(action){
    console.log('Action taken', action)
    console.log('State Management Store: ', this.state)
  }
}

function braCupSizeToChars(bandSize = '32', cupSize = 'A'){ //(number = '32', letter = 'A'){ //

    const size =  `${cupSize}${bandSize.toUpperCase()}`;
    const sizeCategories = {
          XS: ["32A", "32B", "32C"],
          SM: ["32D", "34A", "34B", "34C"],
          MD: ["34D", "36A", "36B", "36C"],
          LG: ["36D", "38A", "38B", "38C"],
          XL: ["38D", "40B", "40C", "40D"],
          SDD: ["32DD", "32DDD", "32G", "34DD", "34DDD"],
          MDD: ["34G", "36DD", "36DDD"],
          LDD: ["36G", "38DD", "38DDD", "38G"],
          XLDD: ["40DD", "40DDD", "40G", "42C", "42D", "42DD"],
          '2XLDD': ["42DDD", "42G", "44D", "44DD", "44DDD"]
      };

      for (const [category, sizes] of Object.entries(sizeCategories)) {
          if (sizes.includes(size)) {
              return category.toLowerCase();
          }
      }
      return false ;
  }

  class EbySubscriptionOptions{
    constructor(){
      this.opts = {
        boxGroup: null,
        styleGroup : styleGroup || null,
        colorGroup : colorGroup || null,
        pantysizeGroup : pantysizeGroup || null,
        brasizeGroup : brasizeGroup || null,
        brameasurementsGroup : brameasurementsGroup || null,
      }
    }
  }
  /*
    ****************************************************************
    * Class Name: EbySubsctiptionBox
    * Description: Represents a subscription box. The class provides 
    * methods for setting and getting various properties of the box 
    * like box type, style, and color. 
    ****************************************************************
  */
  class EbySubsctiptionBox {
    /**
     * Constructs a new EbySubsctiptionBox with specified properties.
     * 
     * @param {string} boxGroup - group or type of the subscription box.
     * @param {string} styleGroup - group of the subscription box.
     * @param {string} colorGroup - group of the subscription box.
     * @param {string} price - of the subscription box.
     * @param {string} discount - applicable to the subscription box.
     */
     constructor(boxGroup, styleGroup, colorGroup, price, discount, timeGroup) {
      //const state = store.getState();
      
      this.box = boxGroup;
      this.style = styleGroup;
      this.color = colorGroup;
      this.price = price;
      this.discount = discount;
      this.pagination = 4;
      this.currentPage = 1;
      this.timeGroup = timeGroup;
      this.renewalPrice = '$40';
      this.memberDesc = '15% off all items every time you shop';
      this.summaryImg = 'https://cdn.shopify.com/s/files/1/0313/4062/5964/files/PROD---hyperpink--sheer--afbralette--missy---prod_lf_2.png?v=1702487868';
      //store.subscribe(() => this.handleStateChange());
    }
    
  
    setPlan(value) {
        this.box = value;
    }
    
    setStyle(value) {
      this.style = value;
    }

    setColor(value) {
      this.color = value;
    }
    
    setPagination(value){
      this.currentPage = value - 1
    }

    getPagination(){
      return `${this.currentPage} of ${this.pagination}`
    }

    getPlan(){
      return this.box;
    }

    getRenewal(){
      return this.renewalPrice;
    }

    getMemberDesc(){
      return this.memberDesc;
    }

    getSummarImg(){
      return this.summaryImg;
    }

    updateNamePlan(value){
      const name = this.box;
      if(name.includes('_')){
          return name.replace('_', ' ');
      } else {
          return ''
      }
    }
  
    print() {
      console.log('-------------------------------');
      console.log('Box Plan: ', this.box);
      console.log('Style Plan: ', this.style);
      console.log('Color Plan: ', this.color);
    }

    reset() {
      this.box = '';
      this.style = '';
      this.color = '';
      this.price = '';
      this.discount = '';
      this.pagination = 4;
      this.currentPage = 1;

      const parentElement = document.querySelector('#subsc40-wrapper');
      const removeClass = parentElement.querySelectorAll('.selectedBoxStyle');
      
      removeClass.forEach(function(element) {
        element.classList.remove('selectedBoxStyle');
      });
    }
  }
  /*
    ****************************************************************
    * Class Name: EbyClassicBoxPanty
    * Description: Represents a Classic Panty subscription box. 
    * This class extends the EbySubsctiptionBox class and adds functionality 
    * specific to panty size. It provides methods for setting panty size 
    * and printing box details.
    * Inherits from: EbySubsctiptionBox
    ****************************************************************
  */
  class EbyClassicBoxPanty extends EbySubsctiptionBox {
    /**
     * Constructs a new EbyClassicBoxPanty with specified properties.
     * 
     * @param {string} boxGroup - Group or type of the subscription box (default: 'classic_box').
     * @param {string} price - Price of the subscription box (default: '$39').
     * @param {string} discount - Discount applicable to the subscription box (default: '$19').
     * @param {string} styleGroup - Style group of the subscription box (default: 'fc').
     * @param {string} colorGroup - Color group of the subscription box (default: 'mx').
     * @param {string} pantySize - Size of the panty for this subscription (default: 'xs').
    */
    constructor(boxGroup = 'classic_box_panty', styleGroup = 'fc', colorGroup = 'mx', pantySize = 'xs', timeGroup = 'quarterly') {
      super(boxGroup, styleGroup, colorGroup, timeGroup);
      this.pantySize = pantySize;
      this.pantySizeLetter = '';
      this.price = '$40';
      this.discount = '$20';
      this.description = `3 panties delivered every 3 months`;
      this.memberDesc = '15% off all items every time you shop';
      this.summaryImg = 'https://cdn.shopify.com/s/files/1/0313/4062/5964/files/PROD---hyperpink--sheer--afbralette--missy---prod_lf_2.png?v=1702487868';
    }

    setSizePanty(size) {
      this.pantySize = size;
    }
    setSizePantyLetter(size){
      this.pantySizeLetter = size;
    }

    getSize(){
      return this.pantySize;
    }
    getPantySizeLetter(){
      return this.pantySizeLetter;
    }
    getPrice(){
      return this.price;
    }
    getDiscount(){
      return this.discount;
    }
    getDescription(){
      return `3 panties delivered every 3 months`;
    }
    print() {
        super.print();
        console.log('Panty Size Plan: ', this.pantySize);
    }
    
    reset() {
      super.reset();  // Call parent's reset to reset common attributes
      this.pantySize = 'xs';
      this.pantySizeLetter = '';
      this.color = 'Personalized Colors';
    }
  }
  /*
    ****************************************************************
    * Class Name: EbyClassicBoxCustomBox
    * Description: Represents a Classic Custom Box subscription box. 
    * This class extends the EbySubsctiptionBox class and adds functionality 
    * specific to panty size. It provides methods for setting custom 
    * products and CRUD operations.
    * Inherits from: EbySubsctiptionBox
    ****************************************************************
  */
  class EbyClassicBoxCustomBox extends EbySubsctiptionBox {
    /**
     * Constructs a new EbyClassicBoxCustomBox with specified properties.
     * 
     * @param {string} boxGroup - Group or type of the subscription box (default: 'classic_box').
     * @param {string} price - Price of the subscription box (default: '$39').
     * @param {string} discount - Discount applicable to the subscription box (default: '$19').
     * @param {string} pantySize - Size of the panty for this subscription (default: 'xs').
     * @param {Array} products - Array of custom products for the subscription box.
     */
    constructor(boxGroup = 'classic_box_custom', pantySize = 'xs', colorGroup, products = [], timeGroup = 'quarterly') {
        super(boxGroup, products, colorGroup, timeGroup);
        this.pantySize = pantySize;
        this.pantySizeLetter = '';
        this.products = products;
        this.price = '$40';
        this.discount = '$20';
        this.color = 'Personalized Colors';
        this.description = `3 panties delivered every 3 months`;
        this.memberDesc = '15% off all items every time you shop';
        this.summaryImg = 'https://cdn.shopify.com/s/files/1/0313/4062/5964/files/PROD---hyperpink--sheer--afbralette--missy---prod_lf_2.png?v=1702487868';
      }

      setSizePanty(size) {
        this.pantySize = size;
      }
      setSizePantyLetter(size){
        this.pantySizeLetter = size;
      }

      addProduct(product) {
      if (this.products.length < 3) {
        this.products.push(product);
        this.updateColor();
      }
    }
    removeProduct(productId) {
      const index = this.products.findIndex(product => product.productId === productId);
      if (index !== -1) {
        this.products.splice(index, 1);
        this.updateColor();
      }
    }
    getDescription(){
      return `3 panties delivered every 3 months`;
    }
    updateColor() {
      this.products.forEach((product, index) => {
        const elementId = `eby-subs-custom-color-cru-controller-${index}`;
        const element = document.getElementById(elementId);
        if (element) {
          element.style.backgroundColor = product.productColor;
        }
      });
    }

    isSelectionComplete() {
      // will be the boolean for true or false to go into the next component
      return this.products.length === 3;
    }
  }
  /*
    ****************************************************************
    * Class Name: EbyClassicBoxBra
    * Description: Represents a Classic Bra subscription box. 
    * This class extends the EbySubsctiptionBox class and adds specific 
    * functionality related to bra sizes and measurements. It provides methods 
    * for setting bra sizes and printing box details.
    * Inherits from: EbySubsctiptionBox
    ****************************************************************
  */
  class EbyClassicBoxBra extends EbySubsctiptionBox {
    /**
     * Constructs a new EbyClassicBoxBra with specified properties.
     * 
     * @param {string} boxGroup - Group or type of the subscription box (default: 'class_box').
     * @param {string} price - Price of the subscription box (default: '$39').
     * @param {string} discount - Discount applicable to the subscription box (default: '$19').
     * @param {string} styleGroup - Style group of the subscription box (default: 'bra').
     * @param {string} colorGroup - Color group of the subscription box (default: 'mx').
     * @param {string} brasizeGroup - Size of the bra for this subscription (default: '20').
     * @param {string} brameasurementsGroup - Measurement (cup size) of the bra for this subscription (default: 's').
     */
    constructor(boxGroup = 'class_box_bra', styleGroup = 'bra', colorGroup = 'mx', brasizeGroup = '20', brameasurementsGroup = 's', timeGroup = 'quarterly' ) {
      super(boxGroup, styleGroup, colorGroup, timeGroup);
      this.sizeCup = brasizeGroup;
      this.sizeCupLetter = brameasurementsGroup;
      this.price = '$40';
      this.discount = '$20';
      this.description = `1 bras delivered every 3 months`;
      this.renewalPrice = '$20';
      this.memberDesc = '15% off all items every time you shop';
      this.summaryImg = 'https://cdn.shopify.com/s/files/1/0313/4062/5964/files/PROD---hyperpink--sheer--afbralette--missy---prod_lf_2.png?v=1702487868';
      this.braPrices = {
        'sheer': '$40',
        'support': '$48',
        'only': '$54',
      };
      this.discountBra = {
        'sheer': '$20',
        'support': '$24',
        'only': '$27',
      }
    }
    getDescription(){
      return `1 bras delivered every 3 months`;
    }
    getCupSizeBra(){
      return braCupSizeToChars(this.sizeCupLetter, this.sizeCup);
    }
    

    setSizeBra(size, cup) {
      this.sizeCup = size;
      this.sizeCupLetter = cup;
    }

    getSize(){
      return this.sizeCupLetter + this.sizeCup;
    }
    print() {
        super.print();
        console.log('Bra Size Plan: ', this.sizeCup);
        console.log('Bra Measure Plan: ', this.sizeCupLetter);
    }

    reset() {
      super.reset();  // Call parent's reset to reset common attributes
      this.pantySize = 'xs';
      this.pantySizeLetter = '';
      this.color = 'Personalized Colors';
    }
  }
  /*
    ****************************************************************
    * Class Name: EbyBraBox
    * Description: Represents a Set Box subscription. This class extends 
    * the EbySubsctiptionBox and encompasses both bra and panty options 
    * in a combined set. It provides methods for setting the bra and panty 
    * sizes, the panty style, and printing the box details.
    * Inherits from: EbySubsctiptionBox
    ****************************************************************
  */
  class EbyBraBox extends EbySubsctiptionBox {
    /**
    * Constructs a new EbyBraBox with specified properties.
    * 
    * @param {string} boxGroup - Group or type of the subscription box (default: 'set_box').
    * @param {string} styleGroup - Style group of the bra.
    * @param {string} colorGroup - Color group of the bra.
    * @param {string} brasizeGroup - Size group for the bra (default: '20').
    * @param {string} brameasurementsGroup - Bra cup size (default: 's').
    * @param {string} stylePanty - Style group for the panty (default: 'fc').
    * @param {string} sizePanty - Size of the panty (default: 'xs').
    */
    constructor(boxGroup = 'bra_box', styleGroup = 'bra', colorGroup = 'mx', brasizeGroup = '20', brameasurementsGroup = 's', stylePanty = 'fc', sizePanty = 'xs', timeGroup = 'quarterly') {
      super(boxGroup, styleGroup, colorGroup, stylePanty, sizePanty, timeGroup);
      this.sizeCup = brasizeGroup;
      this.sizeCupLetter = brameasurementsGroup;
      this.stylePanty = stylePanty;
      this.sizePanty = sizePanty;
      this.pantySizeLetter = '';
      this.price = '$39';
      this.discount = '$19.50';
      this.description = `1 bra delivered every 3 months`;
      this.renewalPrice = '$39';
      this.memberDesc = '15% off all items every time you shop';
      this.summaryImg = 'https://cdn.shopify.com/s/files/1/0313/4062/5964/files/PROD---hyperpink--sheer--afbralette--missy---prod_lf_lg.png?v=1703622075';
      this.braPrices = {
        'sheer': '$37',
        'support': '$48',
        'only': '$54',
      };
      this.discountBra = {
        'sheer': '$19.50',
        'support': '$24',
        'only': '$27',
      }
    }

    setSizeBra(size, cup) {
        this.sizeCup = size;
        this.sizeCupLetter = cup;
    }
    setSizePanty(size){
      this.sizePanty = size;
    }
    setStylePanty(style){
      this.stylePanty = style;
    }
    setSizePantyLetter(value){
      this.pantySizeLetter = value;
    }

    getSize(){
      return this.sizeCupLetter + this.sizeCup;
    }
    getCupSizeBra(){
      return braCupSizeToChars(this.sizeCupLetter, this.sizeCup);
    }
    getSizeTwo(){
      return this.sizePanty;
    }
    getPantySizeLetter(){
      return this.pantySizeLetter;
    }
    getDescription(){
      return `1 bra delivered every 3 months`;
    }
    
    print() {
      super.print();
      console.log('Bra Size Plan: ', this.sizeCup);
      console.log('Bra Measure Plan: ', this.sizeCupLetter);
      console.log('Panty Size: ', this.sizePanty);
    }
    reset() {
      super.reset();  // Call parent's reset to reset common attributes
      this.sizeCup = '';
      this.sizeCupLetter = '';
      this.stylePanty = '';
      this.pantySize = 'xs';
      this.pantySizeLetter = '';
      this.color = '';
    }
  }
  /*
    ****************************************************************
    * Class Name: EbySetBox
    * Description: Represents a Premium Box subscription. This class extends 
    * the EbySubsctiptionBox and contains both bra and panty options in 
    * a combined premium package. It provides methods for setting the bra and panty 
    * sizes, the panty style, and printing the box details.
    * Inherits from: EbySubsctiptionBox
    ****************************************************************
  */
  class EbySetBox extends EbySubsctiptionBox {
    /**
     * Constructs a new EbySetBox with specified properties.
     * 
     * @param {string} boxGroup - Group or type of the subscription box (default: 'premium_box').
     * @param {string} styleGroup - Style group of the bra.
     * @param {string} colorGroup - Color group of the bra.
     * @param {string} brasizeGroup - Size group for the bra (default: '20').
     * @param {string} brameasurementsGroup - Bra cup size (default: 's').
     * @param {string} stylePanty - Style group for the panty (default: 'fc').
     * @param {string} sizePanty - Size of the panty (default: 'xs').
    */
    constructor(boxGroup = 'set_box', styleGroup = 'bra', colorGroup = 'mx', brasizeGroup = '20', brameasurementsGroup = 's', stylePanty = 'fc', sizePanty = 'xs', timeGroup = 'quarterly') {
      super(boxGroup, styleGroup, colorGroup, stylePanty, sizePanty, timeGroup);
      this.sizeCup = brasizeGroup;
      this.sizeCupLetter = brameasurementsGroup;
      this.stylePanty = stylePanty;
      this.sizePanty = sizePanty;
      this.price = '$81';
      this.discount = '$30';
      this.description = `1 matching set delivered every 3 months`;
      this.renewalPrice = '$60';
      this.memberDesc = '15% off all items every time you shop';
      this.summaryImg = 'https://cdn.shopify.com/s/files/1/0313/4062/5964/files/PROD---hyperpink--sheer--afbralette--missy---prod_lf_set.png?v=1703622112';
      this.braPrices = { 
        'sheer': '$51',
        'support': '$59',
        'only': '$65',
      };
      this.discountBra = {
        'sheer': '$25.50',
        'support': '$29.50',
        'only': '$32.50',
      }
    }

    setSizeBra(size, cup) {
        this.sizeCup = size;
        this.sizeCupLetter = cup;
    }
    setSizePanty(size){
      this.sizePanty = size;
    }
    setStylePanty(style){
      this.stylePanty = style;
    }
    setSizePantyLetter(value){
      this.pantySizeLetter = value;
    }
    
    getSize(){
      return this.sizeCupLetter + this.sizeCup;
    }
    getCupSizeBra(){
      return braCupSizeToChars(this.sizeCupLetter, this.sizeCup);
    }
    getSizeTwo(){
      return this.sizePanty;
    }
    getPantySizeLetter(){
      return this.pantySizeLetter;
    }
    getDescription(){
      return `1 matching set delivered every 3 months`;
    }

    print() {
        super.print();
        console.log('PantyStyle: ', this.stylePanty);
        console.log('Bra Size Plan: ', this.sizeCup);
        console.log('Bra Measure Plan: ', this.sizeCupLetter);
        console.log('Panty Size: ', this.sizePanty);
    }
    
    reset() {
      super.reset();  // Call parent's reset to reset common attributes
      this.sizeCup = '';
      this.sizeCupLetter = '';
      this.stylePanty = '';
      this.pantySize = 'xs';
      this.pantySizeLetter = '';
      this.color = '';
    }
  }
  /**
    * BoxFactory
    * 
    * This factory class is designed to create and return instances of subscription box 
    * classes based on the provided type. It ensures that the correct type of subscription 
    * box is created without having to know the exact class beforehand.
  */
  class BoxFactory {
    /**
      * Creates and returns an instance of a subscription box based on the given type.
      * 
      * @param {string} type - The type of subscription box to be created.
      * 
      * @return {EbyClassicBoxBra | EbyClassicBoxPanty | EbyClassicBoxCustomBox | EbyBraBox | EbySetBox} - An instance of the appropriate subscription box class.
      * 
      * @throws {Error} - Throws an error if an unknown box type is provided.
    */
    static createBox(type) {
      switch(type) {
        case 'classic_box':
          return new EbyClassicBoxPanty();
        case 'classic_box_bra':
          return new EbyClassicBoxBra();
        case 'classic_box_panty':
          return new EbyClassicBoxPanty();
        case 'classic_box_custom':
          return new EbyClassicBoxCustomBox();
        case 'bra_box':
          return new EbyBraBox();
        case 'set_box':
          return new EbySetBox();
        default:
          throw new Error('Unknown box type');
      }
    }
  }
  
  function boxTypeReducer(state = intialPlanState, action) {
    switch (action.type) {
        case 'SET_BOX_TYPE':
            return {
                ...state,
                boxType: action.payload.boxType,
                currentBox: BoxFactory.createBox(action.payload.currentBox)
            };
        case 'RESET_BOX_TYPE':
            return {
                ...state,
                boxType: null,
                currentBox: null
            };
        default:
            return state;
    }
  }
  const intialStyleState = {
    styles: null
  }
  function stylesReducer(state = intialStyleState, action) {
      switch (action.type) {
          case 'SET_STYLES':
              return {...state, styles: action.payload};
          default:
              return state;
      }
  }
  const intialColorState = {
    colors: null
  }
  function setBraOptReducer(state = intialSetBraOptState, action) {
      switch (action.type) {
          case 'SET_BRA_OPT':
              return {...state, setBraOpt: action.payload};
          case 'RESET_SET_BRA_OPT':
              return {...state, setBraOpt: ''};
          default:
              return state;
      }
  }
  function setPantyOptReducer(state = intialSetPantyOptState, action) {
      switch (action.type) {
          case 'SET_PANTY_OPT':
              return {...state, setPantyOpt: action.payload};
          case 'RESET_PANTY_OPT':
              return {...state, setPantyOpt: ''};
          default:
              return state;
      }
  }
  function colorsReducer(state = intialColorState, action) {
      switch (action.type) {
          case 'SET_COLORS':
              return {...state, colors: action.payload};
          case 'RESET_COLORS':
              return null;
          default:
              return state;
      }
  }
  const intialCboptsState = {
    cbopts: []
  }
  function cboptsReducer(state = intialCboptsState, action) {
      switch (action.type) {
          case 'SET_CBOPTS':
              return [...state, action.payload];
          case 'RESET_CBOPTS':
              return [];
          default:
              return state;
      }
  }
  const initAllCollection = {
    collectionPanty: []
  }
  function collectionPantysReducer(state = initAllCollection, action) {
      switch (action.type) {
          case 'SET_COLLECTIONP':
              return [...state, action.payload];
          case 'RESET_COLLECTIONP':
              return [];
          default:
              return state;
      }
  }
  const intialProductsState = {
    products: [{}, {}, {}]
  }
  function productsReducer(state = intialProductsState, action) {
      switch (action.type) {
          case 'ADD_CURATED': 
            return [...state, action.payload];
          case 'SET_PRODUCTS': 
            return [...state, action.payload, {}, {}];
          case 'ADD_PRODUCTS':
            const addAtIndex  = state.findIndex((product) => Object.keys(product).length === 0);
            if (addAtIndex !== -1) {
              return  [ 
                  ...state.slice(0, addAtIndex),
                  action.payload,
                  ...state.slice(addAtIndex + 1)
              ];
            } 
            return state;
          case 'REMOVE_PRODUCTS':
                // Assuming action.payload is the index of the product to be removed
                if (action.payload >= 0 && action.payload < state.length) {
                    return [
                        ...state.slice(0, action.payload), // Elements before the one to be removed
                        {},
                        ...state.slice(action.payload + 1)  // Elements after the one to be removed
                    ];
                }
                return state; // Return the current state if index is out of range
          case 'REMOVE_BRA':
                const copyState = [...state]
                copyState.pop();
            return [...state, copyState];
          case 'RESET_PRODUCTS':
            return [{}, {}, {}]
          default:
              return state;
      }
  }
  const intialSizeState = {
    sizes: {       // For sets and premiums
      panty: null,
      pantyMeasure: null,
      braCup: null,
      braMeasure: null,
      braSizeChar: null
    }
  }
  function sizesReducer(state = intialSizeState, action) {
      switch (action.type) {
          case 'SET_PANTY_SIZE':
              return { ...state, panty: action.payload };
          case 'SET_PANTY_MEASURE':
              return { ...state, pantyMeasure: action.payload };
          case 'SET_BRA_CUP':
              return { ...state, braCup: action.payload };
          case 'SET_BRA_MEASURE':
              return { ...state, braMeasure: action.payload };
          case 'SET_BRA_SIZE':
              // const sizeCupLetter = action.payload.sizeCupLetter;
              // const sizeCup = action.payload.sizeCup;
              //const braSizeChar = braCupSizeToChars(sizeCup, sizeCupLetter);
              //return { ...state, braSizeChar: braSizeChar}

              return { ...state, braSizeChar: action.payload}
          case 'RESET_SIZES':
            return {
                ...state,
                panty: null, // Or the default value if any
                pantyMeasure: null,
                braCup: null,
                braMeasure: null,
                braSizeChar: null
            };
          default:
              return state;
      }
  }

  function paginationReducer(state, action) {
    switch(action.type) {
      case 'INCREMENT_PAGE':
        return {
          ...state,
          currentPage: state.currentPage + 1
        };

      case 'DECREMENT_PAGE':
        return {
          ...state,
          currentPage: state.currentPage - 1
        };
      default: 
          return state;
    }
  }
  const initialStepState = {
    currentStep: null,
    stepsVisited: [],
  }
  function stepReducer(state = initialStepState, action) {
    switch (action.type) {
        case 'GO_TO_STEP':
            const updatedSteps =  [...(state?.stepsVisited || [])];

            // Only add the step if it doesn't already exist in the array.
            if (!updatedSteps.includes(action.payload)) {
                updatedSteps.push(action.payload);
            }
            return {
                ...state,
                currentStep: action.payload,
                stepsVisited: updatedSteps
            };
        case 'GO_BACK':
          const newStepsVisited = [...state.stepsVisited];
          newStepsVisited.pop();
          return {
              ...state,
              currentStep: newStepsVisited[newStepsVisited.length - 1] || null,
              stepsVisited: newStepsVisited
          };
        case 'RESET_STEP':
          return {
            currentStep: 'eby-sub4-plan',
            stepsVisited: ['eby-sub4-plan']
          }
        case 'GO_NEXT':
            // Handle going next logic
            // ...
        // ... other cases ...
        default:
            return state;
    }
  }
  
  function rootReducer(state = initialStoreState, action) {
    const boxTypeState = boxTypeReducer(state, action);
    const stepState = stepReducer(state, action);

    return {
        boxType: boxTypeState.boxType,
        currentBox: boxTypeState.currentBox,
        styles: stylesReducer(state, action).styles,
        colors: colorsReducer(state, action).colors,
        setBraOpt: setBraOptReducer(state, action).setBraOpt,
        setPantyOpt: setPantyOptReducer(state, action).setPantyOpt,
        cbopts: cboptsReducer(state.cbopts, action),
        products: productsReducer(state.products, action),
        sizes: sizesReducer(state.sizes, action),
        currentStep: stepState.currentStep, 
        stepsVisited: stepState.stepsVisited,
        pagination: paginationReducer(state.pagination, action),
        collectionPanty: collectionPantysReducer(state.collectionPanty, action)
        // ... add other slices of the state as necessary ...
    };
  }
  /**
    * ControllerComponent
    * 
    * A utility controller to manage the visibility state of components 
    * through adding and removing the 'hide' class.
  */
  class ControllerComponent {
    static hideComponent(componentId) {
      const component = document.getElementById(componentId);
      if (component) {
        component.classList.add('hide');
      }
    }

    static showComponent(componentId) {
      const component = document.getElementById(componentId);
      if (component) {
        component.classList.remove('hide');
      }
    }
  }
  /*
    ****************************************************************
    * Class Name: UseCaseProductFetch
    * Description: Represents a use case to fetch products specifically for
    * the custom box subscription. Provides methods for fetching product details
    * from a provided URL, extracting specific product tags, and collecting 
    * relevant product data such as ID, title, color, and image.
    ****************************************************************
  */
  class UseCaseProductFetch {
    /**
     * Constructs a new UseCaseProductFetch instance.
     * 
     * @param {string} url - The endpoint from which the products will be fetched.
    */
    constructor(url, store) {
      this.store = store
      this.url = url;
      this.type = '';
    }

    async fetchProducts() {
      const response = await fetch(this.url);
      const data = await response.json();
      return data.products;
    }

    getFirstTagWithColor(tags) {
      return tags.find(tag => tag.includes('Color-'));
    }
    
    getNamePanty(str, tags){
        const name = str.split(' ').slice(-1);
        let undiesName = '';
        if (name[0].toLowerCase().includes("highwaisted") && tags.includes('mesh')) {
        undiesName = "High Cut"
        } else if (name[0].toLowerCase().includes("highwaisted")) {
        undiesName = name[0].toLowerCase().replace(/highwaisted/g, "High Waisted");
        } else {
        undiesName = name[0]
        }
        
        let finalName = tags.includes('pantyFabric-mesh') ? 'Sheer ' + undiesName : undiesName
        return finalName
    }

    getFirstImageWithProd(images) {
      return images.find(image => image.src.toLowerCase().includes('prod'));
    }

    getFirstTagWithStyle(tags) {
      return tags.find(tag => tag.includes('Type-'));
    }

    async getProducts(type) {

      const products = await this.fetchProducts();
      console.log(products)
      // save the object array here
      this.store.dispatch({
        type: 'SET_COLLECTIONP',
        payload: products
      });
    
      return products.map(product => ({
        id: product.id,
        title: this.getNamePanty(product.title, product.tags),
        colorTag: this.getFirstTagWithColor(product.tags),
        prodImage: this.getFirstImageWithProd(product.images),
        id: product.id,
        title: product.title,
        styleTag: this.getFirstTagWithStyle(product.tags),
        prodType: product.product_type.indexOf('Mesh') >= 0 ? "Sheer" : "Seamless" 
      }));
    }
  }
    
  class CustomBoxSelection {
    constructor() {
      this.selection = [];
    }

    addProduct(product) {
      if (this.selection.length < 3) {
        this.selection.push(product);
        this.updateColor();
        console.log('products: ', this.selection)
      }
    }

    removeProduct(productId) {
      const index = this.selection.findIndex(product => product.productId === productId);
      if (index !== -1) {
        this.selection.splice(index, 1);
        this.updateColor();
      }
    }

    updateColor() {
      this.selection.forEach((product, index) => {
        const elementId = `eby-subs-custom-color-cru-controller-${index}`;
        const element = document.getElementById(elementId);
        if (element) {
          element.style.backgroundColor = product.productImg;
        }
      });
    }

    isSelectionComplete() {
      // will be the boolean for true or false to go into the next component
      return this.selection.length === 3;
    }

    getSelection() {
      return this.selection;
    }
  }

  function validatePropertiesCustom(data, type) {
      const requiredParentProperties = [
          "Shipping Option",
          "_product_type",
          "_shipping_interval_frequency",
          "_shipping_interval_unit_type",
          "_subs_version",
          "_subscription_ids",
          "_tierfour_sub_price",
          "_tiertwo_sub_price_enabled"
      ];
  
      const customProps = [
          "_included_in_custombox",
          "Shipping Option"
      ];
  
      const curatedProps = [
          "_included_in_membershipbox",
          "_product_type",
          "Shipping Option"
      ];
      
      if (!Array.isArray(data) || data.length === 0) {
          console.log("Data must be a non-empty array.");
          return false;
      }
  
      const parentItem = data[data.length - 1];
      const childItems = data.slice(0, -1);
  
      if (!parentItem.hasOwnProperty('properties')) {
          console.log("Missing 'properties' in parent item.");
          return false;
      }
  
      function validatePropertyList(item, properties, subItems) {
          for (let prop of properties) {
              if (!item.properties.hasOwnProperty(prop) || item.properties[prop] == null || item.properties[prop] === "" || item.properties[prop] === undefined) {
                  console.error(`Invalid or missing property: ${prop}`);
                  return false;
              }
          }
          
           // Correcting ternary operator usage
          if(item.properties["_box_perk"]){
            const isSet = item.properties["_box_perk"].toLowerCase().includes("set");
            const expectedPrice = isSet ? 30 : 20;
            const expectedChildren = isSet ? 2 : 3;
            const totalSubsItems = subItems.reduce((sum, child) => sum + child.quantity, 0);
        
            const validateSubPrice = item.properties["_tierfour_sub_price"] !== expectedPrice;
            const validateSubChildren = totalSubsItems !== expectedChildren;
        
            if (validateSubPrice || validateSubChildren) {
                console.error("Subscription validation failed:", {
                    expectedPrice, actualPrice: item.properties["_tierfour_sub_price"],
                    expectedChildren, actualChildren: subItems.length
                });
                return false;
            }
          }
          return true;
      }

      
      if (!validatePropertyList(parentItem, requiredParentProperties, childItems)) {
          return false;
      }
  
      let typeSpecificProps = type === 'custom' ? customProps : type === 'curated' ? curatedProps : null;
      if (typeSpecificProps === null) {
          console.log("Invalid type provided. Type must be 'custom' or 'curated'.");
          return false;
      }
  
      for (let item of childItems) {
          if (!item.hasOwnProperty('properties') || !validatePropertyList(item, typeSpecificProps)) {
              return false;
          }
      }
  
      return true; // All validations passed
  }
  function validateSetProducts(productA, productB){
    const productNameA = productA;
    const productNameB = productB;

    const isBraA = productA.includes('Bra');
    const isBraB = productB.includes('Bra');

    return (isBraA && !isBraB) || (isBraB && !isBraA);
  }